import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
/*
 *  Icon
 *    Scripts for various icon tasks.
 *
 *  Version:
 *    1.0.0 - 2018/11/30
 */
import $ from 'jquery';
import '@iconfu/svg-inject';
export var IMAGE_SELECTOR = "img[src*='.svg']";
export var InitialzeSVGImages = function InitialzeSVGImages() {
  $(IMAGE_SELECTOR).each(function (e, i) {
    return SVGInject(i);
  });

  //Dom's weird fixing the SVGs to have unique classes for their selectors.
  $('svg').each(function (i, e) {
    var randomClass = null;
    while (!randomClass) {
      randomClass = "cust-svg-".concat(Math.round(Math.random() * 999999));
      if (!$(".".concat(randomClass)).length) break;
      randomClass = null;
    }
    var self = $(e);
    self.addClass(randomClass);

    //I'm going to find all root selectors and prepend them with our new specific
    //selector. Some SVGs will have more than one <style>, hence the .each()
    var elStyle = self.find('style');
    $(elStyle).each(function (i, e) {
      var styleEl = $(e);
      var elStyleRaw = styleEl.html();
      elStyleRaw = elStyleRaw.split('}').map(function (def) {
        var selectors = def.split('.');
        if (selectors.length < 2) return def;
        selectors[0] = ".".concat(randomClass, " ");
        return selectors.join('.');
      }).join('}');
      styleEl.html(elStyleRaw);
    });
  });
};
$(document).ready(function () {
  return InitialzeSVGImages();
});
$(document).on('load', IMAGE_SELECTOR, function () {
  return InitialzeSVGImages();
});